import { AsyncContainerModule } from "inversify";
import {
  InsightsAIDreGateway,
  InsightsAIDreGatewayDi
} from "../services/InsightsAIDreGateway";
import InsightsAIDreGatewayAdapter from "../services/InsightsAIDreGatewayAdapter";

export const insightsDreContainer = new AsyncContainerModule(async (bind) => {
  bind<InsightsAIDreGateway>(InsightsAIDreGatewayDi).to(
    InsightsAIDreGatewayAdapter
  );
});
